import Cookies from "js-cookie";
import { Navigate, Outlet } from "react-router-dom";

// Gate for the protected app shell: if there's no auth token, send the user
// to the login page instead of rendering a page that would only 401.
const RequireAuth = () => {
  const token = Cookies.get("access_token");
  const isAuthed = Boolean(token) && token !== "undefined";
  return isAuthed ? <Outlet /> : <Navigate to="/login" replace />;
};

export default RequireAuth;
